import * as React from "react";
const SvgCheck = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M3.3335 10.5092L7.43606 14.5833L16.6668 5.41666",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
export default SvgCheck;
